<div class="row">

    <div class="col-md-6">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Employee</h4>
                <button type="button" class="btn btn-info waves-effect waves-light float-right" (click)="nuevoEmpleado()" *ngIf="empleadoSeleccionado"> New Employee</button>
                <h6 class="card-subtitle">Update Info</h6>


                <form class="form-horizontal p-t-20" [formGroup]="empleadoForm" (submit)="guardarEmpleado()">


                    <div class="form-group row" *ngIf="empleadoSeleccionado">
                        <label for="exampleInputuname3" class="label">Photo</label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <img class="w200" [src]="empleadoSeleccionado.img | imagen: 'employees'" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exampleInputuname3" class="label">Name</label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="input-group-addon"><i class="ti-user"></i></div>
                                <input type="text" class="form-control" id="exampleInputuname3" formControlName="name" placeholder="Name Employee">
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exampleInputuname3" class="label">Last Name</label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="input-group-addon"><i class="ti-user"></i></div>
                                <input type="text" class="form-control" id="exampleInputuname3" formControlName="lastname" placeholder="Last Name Employee">
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exampleInputEmail3" class="label">Type Doc</label>
                        <div class="col-sm-9">

                            <div class="input-group">
                                <div class="input-group-addon"><i class="ti-menu-alt"></i></div>
                                <select class="form-control" formControlName="typedoc">
                                  <option value="">Select</option>
                                  <option *ngFor="let item of typedocList" [value]="item">{{item}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exampleInputuname3" class="label">Number Doc</label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="input-group-addon"><i class="ti-id-badge"></i></div>
                                <input type="text" class="form-control" id="exampleInputuname3" formControlName="document" placeholder="#">
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exampleInputEmail3" class="label">Area/SubArea</label>
                        <div class="col-sm-12">
                            <div class="input-group">
                                <select class="form-control" formControlName="area">
                                  <option value="">Select Area</option>
                                  <option *ngFor="let item of areas" [value]="item._id">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-10" *ngIf="areaSeleccionado">
                            <div class="input-group ml-2">
                                <select class="form-control" formControlName="subarea">
                                  <option value="">Select SubArea</option>
                                  <option *ngFor="let item of subareas" [value]="item._id">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-b-0 mt-2">
                        <div class="offset-sm-3 col-sm-9">
                            <button type="submit" [disabled]="empleadoForm.invalid" class="btn btn-success waves-effect waves-light">
                              <i class="fa fa-save"></i>
                              Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="col animate fadeIn fast" *ngIf="subareaSeleccionado">

        <div class="card">
            <div class="card-body text-center">
                <h4 class="card-title">{{areaname}}</h4>
                <h6 class="card-subtitle">{{subareaSeleccionado.name}}</h6>

                <img class="img-thumbnail" [src]="areaSeleccionado.img | imagen: 'areas'" [alt]="areaSeleccionado.nombre">

            </div>
        </div>

    </div>

</div>